import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { IUserFrontend } from '../../../entity/User'
import { hideModal } from '../../actions/modalActions'
import { getUrlWithVersion } from '../../../api/api'

export const createNewUser = createAsyncThunk<
    { user: IUserFrontend },
    {
        user: IUserFrontend
        initialState: any
        setState: Function
        setTouched: Function
    },
    ThunkConfig<string>
>('usersSlice/createNewUser', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { user, initialState, setState, setTouched } = args

    try {
        await api.post(getUrlWithVersion(`/users`), user)
        throwSuccessMessage(`Success!`)

        setTimeout(() => {
            dispatch(hideModal())
            setState(initialState)
            setTouched({})
        }, 0)

        return { user }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to add new user')
    }
})